import ArcaneApiGateway from '@/services/arcane-api-gateway';
import { registerGatewayClient } from '~/services/api/clients';
import { setArcaneApiGateway } from '~/store/authStore';

export default {
  install: (app) => {
    const {
      config: { globalProperties },
    } = app;
    const instance = new ArcaneApiGateway(globalProperties);
    app.provide('arcaneApiGateway', instance);
    setArcaneApiGateway(instance);
    registerGatewayClient(instance);
  },
};
